import { z } from 'zod';

export const SearchFormSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  tk: z.string().optional(),
  ngay_hd1: z.string().optional(),
  ngay_hd2: z.string().optional(),
  ma_kh: z.string().optional(),
  so_du: z.string().optional(),
  mau_bc: z.string().optional(),
  ngay_bc: z.string().optional(),
  report_filtering: z.string().optional(),
  data_analysis_struct: z.string().optional()
});

export type SearchFormValues = z.infer<typeof SearchFormSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  tk: '',
  ngay_hd1: '',
  ngay_hd2: '',
  ma_kh: '',
  so_du: '0',
  mau_bc: '20',
  ngay_bc: new Date().toISOString().split('T')[0],
  report_filtering: '0',
  data_analysis_struct: '0'
};
